import React from "react";
import styles from "./Checkbox.module.scss";
import { Checkbox as UICheckbox } from "@yoti/ui-kit-components-react/checkbox";

export const Checkbox = ({ label, onChange, checked }) => {
  return (
    <div className={styles.checkbox}>
      <UICheckbox label={label} onChange={onChange} checked={checked} />
    </div>
  );
};
